var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popin",class:{'is-active': _vm.isActive }},[_c('div',{staticClass:"popin-container"},[_c('button',{staticClass:"popin-close",attrs:{"type":"button"},on:{"click":_vm.onClose}},[_c('i',{staticClass:"ic ic-close"})]),_c('div',{staticClass:"popin-content"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }